module.exports = __webpack_public_path__ + "static/media/thecompany.45b728e5.png";